
import { mapState } from 'vuex'
import headSearch from '~/components/common/headSearch.vue'
import allMenu from '~/components/common/allMenu.vue'
import languageList from '~/static/json/languageList.json'
import loginBox from '~/components/userLogin/loginBox.vue'
import googleLogin from '~/components/login/googleLogin.vue'
import { bus } from '~/assets/js/eventBus'
const _ = require('lodash')
export default {
  components: {
    'head-search': headSearch,
    'all-menu': allMenu,
    'login-box': loginBox,
    'google-login': googleLogin
  },
  props: {
    topadshow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sidesObj: { langPop: true, menuPop: true, showSides: false }, // 是否展示侧边栏菜单导航（移动端）
      // 头部
      langList: languageList, // 语言列表
      huntObj: { showMask: false, showBox: false, showInput: true }, // 是否展示搜索框，并打开遮罩
      // loginShow: false, // 是否弹出登录框
      menuIndex: '',
      allmenuShow: false, // 下拉所有菜单是否显示
      personalShow: false,
      autoshow: false, // 表单是否自动聚焦
      compareCode: '', // 对比Code
      isEnterprise: false, // 是否为企业用户
      langSwatch: false, // 是否展示切换语言
      switchlangtxt: '您当前语言与浏览器默认语言不一致，是否切换？',
      switchtxt: '切换',
      swlangslate: [
        {
          type: 'zh-cn',
          one: '您当前语言与浏览器默认语言不一致，是否切换？',
          two: '切换'
        },
        {
          type: 'ar',
          one: 'اللغة الحالية تختلف عن اللغة الافتراضية للمتصفح.  هل تريد التبديل؟',
          two: 'تغيير'
        },
        {
          type: 'de',
          one: 'Die aktuelle Sprache unterscheidet sich von der Standardsprache des Browsers. Möchten Sie wechseln?',
          two: 'Wechsel'
        },
        {
          type: 'en',
          one: "Current language is different from browser's default language. Do you want to switch?",
          two: 'Switch'
        },
        {
          type: 'es',
          one: 'Su idioma actual es diferente del idioma predeterminado de su navegador. ¿Quieres cambiar?',
          two: 'Cambiar'
        },
        {
          type: 'fil',
          one: 'Ang iyong kasalukuyang wika ay iba sa default na wika ng iyong browser. Gusto mo bang lumipat?',
          two: 'Lumipat'
        },
        {
          type: 'fr',
          one: 'La langue actuelle est différente de la langue par défaut du navigateur. Voulez-vous changer ?',
          two: 'Commuter'
        },
        {
          type: 'hi',
          one: 'आपकी वर्तमान भाषा आपके ब्राउज़र की डिफ़ॉल्ट भाषा से भिन्न होती है. क्या आप स्विच करना चाहते हैं?',
          two: 'स्विच'
        },
        {
          type: 'id',
          one: 'Bahasa saat ini berbeda dengan bahasa default browser. Apakah Anda ingin beralih?',
          two: 'Beralih'
        },
        {
          type: 'it',
          one: 'La tua lingua attuale non è coerente con la lingua predefinita del browser. Vuoi cambiarla?',
          two: 'cambia'
        },
        {
          type: 'ja',
          one: '現在の言語はブラウザのデフォルト言語とは異なります。 切り替えますか?',
          two: '切替'
        },
        {
          type: 'ko',
          one: '현재 언어가 브라우저 기본 언어와 일치하지 않습니다. 전환하시겠습니까?',
          two: '교체'
        },
        {
          type: 'pt',
          one: 'Seu idioma atual é diferente do idioma padrão do seu navegador. Você quer mudar?',
          two: 'Alternar'
        },
        {
          type: 'tr',
          one: 'Mevcut diliniz tarayıcınızın varsayılan dilinden farklı. Geçiş yapmak istiyor musun?',
          two: 'Geçiş'
        },
        {
          type: 'ru',
          one: 'Текущий язык отличается от языка браузера по умолчанию. Хотите переключиться?',
          two: 'Переключить'
        },
        {
          type: 'th',
          one: 'ภาษาปัจจุบันของคุณต่างจากภาษาเริ่มต้นของเบราว์เซอร์ คุณต้องการที่จะเปลี่ยนหรือไม่?',
          two: 'สวิตซ์'
        },
        {
          type: 'vi',
          one: 'Bạn có muốn đổi sang ngôn ngữ mặc định của trình duyệt không?',
          two: 'Đổi sang'
        },
        {
          type: 'zh',
          one: '您當前語言與瀏覽器默認語言不一致，是否切換？',
          two: '切換'
        },
        {
          type: 'zh-hk',
          one: '您當前語言與瀏覽器默認語言不一致，是否切換？',
          two: '切換'
        },
        {
          type: 'zh-tw',
          one: '您當前語言與瀏覽器默認語言不一致，是否切換？',
          two: '切換'
        }
      ],
      browserLanguage: '',
      headHeight: 0
    }
  },
  computed: {
    ...mapState({
      mobile: 'mobile',
      navList: 'navList',
      visibleList: 'visibleList',
      invisibleList: 'invisibleList',
      langshow: 'langshow',
      cookieHost: 'cookieHost'
    }),
    userLink() {
      if (this.isEnterprise) {
        return [
          {
            // 用户中心跳转
            name: '我的企业',
            link: `https://www.wikifxmanager.com/${this.$store.state.LanguageCode}/login?contentcookie=${encodeURI(this.$store.state.contentcookie)}`,
            icon: 'icon-Frame15',
            key: '35679'
          },
          {
            // 用户中心跳转
            name: '我的发布',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/serve.html`,
            icon: 'icon-zhongxin',
            key: '21052'
          },
          {
            name: '我的订单',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/vip.html`,
            icon: 'icon-guanzhu-1',
            key: '21051'
          },
          {
            name: '我的收藏',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/dealer.html`,
            icon: 'icon-dingdan',
            key: '34613'
          },
          {
            name: '我的担保',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/epc.html`,
            icon: 'icon-fabu-1',
            key: '21053'
          },
          {
            name: '个人设定',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/setting.html`,
            icon: 'icon-danbao',
            key: '34614'
          },
          {
            name: this.$store.state.user.vest ? '24366' : '21865',
            link: 'javascript:void(0)',
            icon: 'icon-quit'
          }
        ]
      } else {
        return [
          {
            // 用户中心跳转
            name: '我的发布',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/serve.html`,
            icon: 'icon-zhongxin',
            key: '21052'
          },
          {
            name: '我的订单',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/vip.html`,
            icon: 'icon-guanzhu-1',
            key: '21051'
          },
          {
            name: '我的收藏',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/dealer.html`,
            icon: 'icon-dingdan',
            key: '34613'
          },
          {
            name: '我的担保',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/epc.html`,
            icon: 'icon-fabu-1',
            key: '21053'
          },
          {
            name: '个人设定',
            link: `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/setting.html`,
            icon: 'icon-danbao',
            key: '34614'
          },
          {
            name: this.$store.state.user.vest ? '24366' : '21865',
            link: 'javascript:void(0)',
            icon: 'icon-quit'
          }
        ]
      }
    },
    // 本项目logo
    fxLogo() {
      const selectedLang = this.currLangCode()
      if (selectedLang == 'zh-cn') return 'https://resources1.interface003.com/web20/img/home/logo-cn.svg'
      else if (['zh-tw', 'zh-hk', 'zh'].includes(selectedLang)) return 'https://resources1.interface003.com/web20/img/home/logo-tw.svg'
      else return 'https://resources1.interface003.com/web20/img/home/logo-en.svg'
    },
    langtype() {
      // 长短语言类型0短语言1长语言
      let lang = ''
      if (this.$store.state.LanguageCode == 'zh-cn' || this.$store.state.LanguageCode == 'zh-hk' || this.$store.state.LanguageCode == 'zh-tw' || this.$store.state.LanguageCode == 'zh') lang = '0'
      else lang = '1'
      return lang
    },
    // 当前选择的语言
    langName() {
      let langText = ''
      if (this.currLangCode() == 'zh-hk') langText = '繁體中文(香港)'
      else if (this.currLangCode() == 'zh-tw') langText = '繁體中文(臺灣)'
      else langText = this.getMyLang({ LanguageCode: this.currLangCode() })?.Language || 'English'
      return langText
    },
    educateshow() {
      // 教育显示得语言
      const l = 'zh-tw,en,ru,vi,th,id,es,fil'
      if (l.includes(this.$store.state.LanguageCode)) return true
      else return false
    },
    exposhow() {
      // EXPO
      const l = 'zh-cn,zh,en,vi,th'
      if (l.includes(this.$store.state.LanguageCode)) return true
      else return false
    },
    isDealerDeatilsPage() {
      // 是否为交易商详情页
      if (this.$route.name == 'lang-dealer-id') return true
      else return false
    }
  },
  watch: {
    '$store.state.user'(newVal) {
      console.log('newVal: ', newVal)
      if (newVal) {
        console.log('newVal: ', newVal)
        setTimeout(() => {
          console.log('this.$store.state.contentcookie', this.$store.state.contentcookie)

          this.getuserisenterprise()
        }, 0)
      } else {
        this.isEnterprise = false
      }
    }
  },
  created() {
    //
    // process.client
    if (process.client) return
    const art = [
      'lang-learnlist-graduation-id',
      'lang-learnlist-undergraduate-id',
      'lang-learnlist-highschool-id',
      'lang-learnlist-summer-camp-id',
      'lang-learnlist-middleschool-id',
      'lang-learnlist-elementary.html',
      'lang-learnlist-pre-school-id',
      'lang-learnlist-id',
      'lang-authority-id',
      'lang-evaluation-id',
      'lang-wikilist-id',
      'lang-brokernews-id',
      'lang-industry-id',
      'lang-original-id',
      'lang-news-id',
      'wikishow',
      'learn',
      'lang-information-id',
      'lang-discover-id',
      'lang-best-id',
      'lang-specialist-id',
      'lang-compare-forex-id',
      'lang-compare-id',
      'lang-newsdetail-id',
      'lang-learn-id',
      'lang-class-id',
      'lang-wikilist.html',
      'lang-wikishow-id',
      'lang-intro-id',
      'lang-exposure-detail-id',
      'lang-exposure-safeguard-code',
      'lang-market-detail-details',
      'lang-exposure-detail-id',
      'lang-survey-sid',
      'lang-word-id'
    ]
    // console.log(this.$route.name, 123, art.includes(this.$route.name))
    if (!art.includes(this.$route.name)) this.$store.commit('setlangshow', true)
    // 处理可见区域的菜单项
    const arr = [...this.$store.state.menuData]
    if (!this.educateshow && arr.map((item) => item.code).includes('menu_education_new')) arr.splice(arr.map((item) => item.code).indexOf('menu_education_new'), 1)
    // if (!this.exposhow && arr.map((item) => item.code).includes('menu_wikiexpo')) arr.splice(arr.map((item) => item.code).indexOf('menu_wikiexpo'), 1)
    // this.navList = [...arr]
    this.$store.commit('setnavList', arr)
    // this.visibleList = _.cloneDeep(arr)
    this.$store.commit('setvisibleList', _.cloneDeep(arr))
  },
  mounted() {
    const swlang = this.$cookies.get('swlang')
    const art = ['lang-discover-id', 'lang-best-id', 'lang-newsdetail-id', 'lang-learn-id', 'lang-wikilist.html', 'lang-wikishow-id', 'lang-intro-id', 'lang-market-detail-details', 'lang-word-id']
    const path = !art.includes(this.$route.name)
    if (!swlang && path) {
      if (navigator.language) {
        console.log('navigator.language: ', navigator.language.toLowerCase())
        /* .split(',')?.[0]?.toLowerCase() || '' */
        let lang = navigator.language.split(',')[0].toLowerCase()
        if (lang != 'zh-cn' && lang.includes('-')) {
          lang = lang.split('-')[0]
        }
        this.browserLanguage = lang
        if (this.$store.state.langList.includes(lang)) {
          if (this.$store.state.LanguageCode != lang) {
            this.swlangslate.forEach((item) => {
              if (item.type == lang) {
                this.switchlangtxt = item.one
                this.switchtxt = item.two
              }
            })
            // this.$store.commit('setlangsw', true)
          }
        }
      }
    }

    if (this.isDealerDeatilsPage && this.mobile) this.getComapreName()
    this.getuserisenterprise() // 判断是否为企业用户,如果是企业用户下拉展示我的企业
    this.$nextTick(() => {
      // setTimeout(() => {
      //   this.$store.commit('setlangshow', true)
      // }, 1000)
      // this.langshow = true
      // 通过计算菜单栏总长度，判断是否隐藏几项
      this.totalEle()
      window.onresize = () => {
        // 处理可见区域的菜单项
        const arr = [...this.$store.state.menuData]
        if (!this.educateshow) arr.splice(arr.map((item) => item.code).indexOf('menu_education_new'), 1)
        // if (!this.exposhow) arr.splice(arr.map((item) => item.code).indexOf('menu_wikiexpo'), 1)
        // this.navList = [...arr]
        this.$store.commit('setnavList', arr)
        // this.visibleList = _.cloneDeep(arr)
        this.$store.commit('setvisibleList', _.cloneDeep(arr))
        this.$nextTick(() => {
          this.totalEle()
        })
        this.langheight()
      }
      document.addEventListener(
        'click',
        () => {
          this.personalShow = false
        },
        { passive: true }
      )
    })
    this.langheight()
    this.getvh()
    console.log('$store.state.user.userId', this.$store.state.user)
    console.log(this.$store.state)
  },
  methods: {
    swlangfn(i) {
      // i 为1切换 2关闭
      this.$store.commit('setlangsw', false)
      // const currTime = new Date()
      // const expires = new Date(currTime.setTime(currTime.getTime() + 3650 * (24 * (3600 * 1000))))

      const currDate = new Date()
      currDate.setHours(23)
      currDate.setMinutes(59)
      currDate.setSeconds(59)
      this.$Cookie.set('swlang', 1, {
        expires: currDate,
        path: '/',
        domain: this.$store.state.cookieHost
      })
      // let lang = navigator.language.split(',')[0].toLowerCase()
      // if (lang != 'zh-cn' && lang.includes('-')) {
      //   lang = lang.split('-')[0]
      // }
      if (i == 1) {
        location.href = `/${this.browserLanguage}/${this.$store.state.path}`
      }
    },
    async getuserisenterprise() {
      if (this.$store.state.user?.userId) {
        const getuser = await this.$api.common
          .CV3(
            // 用户信息
            {
              ApplicationType: 7,
              CountryCode: this.$store.state.CountryCode,
              LanguageCode: this.$store.state.LanguageCode,
              userId: this.$store.state.user.userId ? this.$store.state.user.userId : ''
            },
            {
              Routes: 'usercenter$getuserv5'
            }
          )
          .catch(() => {
            console.log('getuserv5')
          })

        console.log('getuser: ', getuser)
        if (getuser && getuser.usercenter && getuser.usercenter.getuserv5 && getuser.usercenter.getuserv5.data) {
          console.log('this.$store.state.user', this.$store.state.user)
          if (getuser.usercenter.getuserv5.data.EnterpriseCode) this.isEnterprise = true
          else this.isEnterprise = false
          // if (this.$store.state.user.avatar != getuser.usercenter.getuserv5.data.showAvataraddress) {
          //   this.accessCookie({
          //     userId: getuser.usercenter.getuserv5.data.userId,
          //     nick: getuser.usercenter.getuserv5.data.showNickName,
          //     avatar: getuser.usercenter.getuserv5.data.showAvataraddress
          //   })
          // }
        }
        console.log('this.isEnterprise: ', this.isEnterprise)
      }
    },
    async accessCookie(userInfo) {
      // 加密cookie存cookie
      console.log('userInfo1: ', userInfo)
      this.$store.commit('setUser', {
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick,
        avatar: userInfo.showAvataraddress || userInfo.avatar
      })

      const getcookie = await this.$api.common
        .CV3(
          // epc列表
          {
            userId: userInfo.userId,
            nick: userInfo.showNickName || userInfo.nick,
            avatar: userInfo.showAvataraddress || userInfo.avatar
          },
          {
            Routes: 'usercenter$getcookie'
          }
        )
        .catch(() => {
          console.log('getcookie')
        })
      if (getcookie && getcookie.usercenter && getcookie.usercenter.getcookie) {
        if (!getcookie.usercenter.getcookie.success) return this.$message.error(getcookie.usercenter.getcookie.extra) // 数据错误
        if (this.$store.state.host.includes('wikifx')) {
          this.CookieSet('DJkdikKMG', getcookie.usercenter.getcookie.data.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
        } else if (this.$store.state.host.includes('fxeye')) {
          this.CookieSet('ViLartidlakd', getcookie.usercenter.getcookie.data.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
        } else {
          this.$cookies.set('WsdsfgDGdagYms', getcookie.usercenter.getcookie.data.Value)
          const postdata = {
            op_type: 'setCookie',
            url: '',
            parm: getcookie.usercenter.getcookie.data.Value
          }
          window.parent.postMessage(postdata, '*')
        }
        this.$store.commit('setUsercookie', getcookie.usercenter.getcookie.data.Value)
      }
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    },
    // 添加桌面快捷方式
    // async toDesktop () {
    toDesktop() {
      // const workbox = await window.$workbox
      // if (workbox) {
      // console.log('workbox', workbox)
      this.beforeinstallpromptListener()
      // Service worker is available
      // }
    },
    install() {
      // let e
      // const _that = this
      // null === (e = this.pwaTarget) || void 0 === e || e.prompt().then((function(e) {
      //     "accepted" === e.outcome && (_that.pwaTarget = null)
      // }
      // ))
    },
    beforeinstallpromptListener() {
      // const _that = this
      // if (window) {
      //   // window.addEventListener('beforeinstallprompt', (t) => {
      //   //   // t.preventDefault()
      //   //   // _that.pwaTarget = t
      //   //   t.prompt()
      //   //   // 判断用户是否安装
      //   //   event.userChoice.then((e) => {
      //   //     // install = true
      //   //     console.log('安转成功')
      //   //   })
      //   // }, { once: true })
      // }
    },
    personalFn() {
      // 点击头像下拉框是否显示
      this.personalShow = true
    },
    quit(val) {
      // 退出登录DJkdikKMG
      // 头像退出登录
      if (val != 'icon-quit') return
      const DJkdikKMG = this.$cookies.get('DJkdikKMG')
      const ViLartidlakd = this.$cookies.get('ViLartidlakd')
      const WsdsfgDGdagYms = this.$cookies.get('WsdsfgDGdagYms')
      const contentcookie = DJkdikKMG || ViLartidlakd || WsdsfgDGdagYms
      console.log('contentcookie::: ', contentcookie)
      if (contentcookie) {
        this.dialogFn(false, 'menuPop')
        this.$cookies.remove('DJkdikKMG', {
          path: '/',
          domain: this.$store.state.cookieHost,
          sameSite: 'none',
          secure: true
        })
        this.$cookies.remove('ViLartidlakd', {
          path: '/',
          domain: this.$store.state.cookieHost,
          sameSite: 'none',
          secure: true
        })
        this.$cookies.remove('WsdsfgDGdagYms', {
          path: '/',
          domain: this.$store.state.cookieHost
        })

        const postdata = {
          op_type: 'loginout',
          url: '',
          parm: ''
        }
        window.parent && window.parent.postMessage(postdata, '*')

        this.$nextTick(() => {
          const VEST = this.$cookies.get('VEST')
          if (VEST) {
            this.$store.commit('setUsercookie', VEST)
            this.$api.home
              .clientgetUsercookie({
                contentcookie: VEST
              })
              .catch(() => {
                console.log('login')
              })
              .then((res) => {
                console.log(res.result, 1112)
                this.$store.commit('setUser', res.result)
                // this.$cookies.remove('VEST', { path: '/', domain: this.$store.state.cookieHost })
                location.href = `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/waistcoat.html`
              })
          } else {
            this.$store.commit('setUser', {})
            this.$store.commit('setUsercookie', '')
          }
        })
        const quitetoken = this.$cookies.get('quitetoken')?.split(',')
        this.$api.common
          .CV3(
            {
              token: quitetoken?.[0],
              reFreshToken: quitetoken?.[1]
            },
            {
              Routes: 'usercenter$userlogoff'
            }
          )
          .catch((err) => {
            console.log(err, 111)
          })
        this.$cookies.remove('logintoken', {
          path: '/',
          domain: this.$store.state.cookieHost
        })
        this.$cookies.remove('quitetoken', {
          path: '/',
          domain: this.$store.state.cookieHost
        })
        this.$cookies.remove('refreshtime', {
          path: '/',
          domain: this.$store.state.cookieHost
        })
      } else {
        this.$cookies.remove('VEST', {
          path: '/',
          domain: this.$store.state.cookieHost
        })
        this.$store.commit('setUser', {})
        this.$store.commit('setUsercookie', '')
      }
    },
    menuSon(code) {
      // 子组件展开和缩起来
      if (this.menuIndex == code) {
        this.menuIndex = ''
        return
      }
      this.menuIndex = code
    },
    menuOver(item) {
      // 鼠标移入菜单事件
      this.menuIndex = item.code
    },
    menuLeave() {
      // 鼠标移出菜单事件
      this.menuIndex = ''
    },
    totalEle() {
      const [navDom, totalWidth] = [document.getElementsByClassName('item-nav'), this.$refs?.menuDom?.offsetWidth - 50]
      const navLen = navDom?.length || 0 // 栏目数量
      let [tempWidth, navIdx] = [0, 0]
      for (navIdx = 0; navIdx < navLen; navIdx++) {
        tempWidth = _.add(_.add(navDom[navIdx]?.offsetWidth, 23), tempWidth) // 所有元素的宽度
        if (tempWidth > totalWidth) break
        // this.visibleList = _.slice(this.navList, 0, _.add(navIdx, 1))
        this.$store.commit('setvisibleList', _.slice(this.navList, 0, _.add(navIdx, 1)))
      }
      // if (navIdx < navLen) this.invisibleList = _.slice(this.navList, navIdx)
      if (navIdx < navLen) this.$store.commit('setinvisibleList', _.slice(this.navList, navIdx))
    },
    login() {
      this.dialogFn(false, 'menuPop')
      // 点击登录
      const DJkdikKMG = this.$cookies.get('DJkdikKMG')
      const ViLartidlakd = this.$cookies.get('ViLartidlakd')
      const WsdsfgDGdagYms = this.$cookies.get('WsdsfgDGdagYms')
      const contentcookie = DJkdikKMG || ViLartidlakd || WsdsfgDGdagYms
      if (contentcookie) return false
      // this.$refs.loginBox.close = true
      this.$store.commit('loginClose', true)
      // this.loginShow = true
    },
    // 更换语言
    langFn(obj = {}, isDelay = false) {
      const langCode = obj?.LanguageCode || 'en'
      const { name = '', query = '' } = this.$route
      const params = this.$route.params || {}
      params.lang = langCode
      if (isDelay) this.dialogFn()
      const reloadTimer = setTimeout(
        () => {
          clearTimeout(reloadTimer)
          const routeData = this.$router?.resolve({ name, params, query })
          location.href = routeData?.href
        },
        isDelay ? 50 : 0
      )
    },
    // 侧边栏更换菜单
    menuFn(obj = {}) {
      this.dialogFn(false, 'menuPop')
    },
    // 打开/关闭侧边栏弹框
    dialogFn(isOpen = false, domName = 'langPop') {
      _.assign(this.sidesObj, isOpen ? { [domName]: false } : { showSides: false }) // 打开弹框时，先移除隐藏样式；关闭弹框时，内容区先消失
      const openTimer = setTimeout(() => {
        clearTimeout(openTimer)
        _.assign(this.sidesObj, isOpen ? { showSides: true } : { [domName]: true }) // 打开弹框一段时间后，内容区才出现；关闭弹框一段时间后，才添加隐藏样式
        if (domName == 'menuPop') {
          if (!this.sidesObj.menuPop) {
            document.body.style.overflow = 'hidden'
          } else {
            document.body.style.overflow = 'auto'
          }
        }
        if (domName == 'langPop') {
          if (!this.sidesObj.langPop) {
            document.body.style.overflow = 'hidden'
          } else {
            document.body.style.overflow = 'auto'
          }
        }
      }, 50)
    },
    // 展示搜索框，并打开遮罩
    expandInput(isOpen = false) {
      // _.assign(
      //   this.huntObj,
      //   isOpen ? { showMask: false, showBox: false } : { showInput: false }
      // )
      // const expandTimer = setTimeout(
      //   () => {
      //     clearTimeout(expandTimer)
      //     _.assign(
      //       this.huntObj,
      //       isOpen ? { showInput: true } : { showMask: true, showBox: true }
      //     )
      //   },
      //   isOpen ? 0 : 200
      // )
      // this.$nextTick(() => {
      //   // this.autoshow = true
      //   if (isOpen) {
      //     this.$refs.pcsearch.$refs.pcinput.focus()
      //     this.$refs.pcsearch.getfocus()
      //   }
      // })
    },
    async getComapreName() {
      // 获取对比Name
      const codes = this.$route.params?.id?.replace('.html', '')?.toString()
      console.log('codes::: ', codes)
      if (codes) {
        const res = await this.$api.compare.clientGetUrlName({ codes }).catch(() => {
          console.log('获取交易商URLNameERROR')
        })
        console.log('res::: ', res)
        if (res && res?.length > 0 && res[0].Name) this.compareCode = res && res[0].Name
        else this.compareCode = codes
      }
    },
    downloadToSensor() {
      this.sensorTrackDownload(this.$route)
    },
    claimfn() {
      bus.$emit('claimfn')
    },
    parterfn() {
      bus.$emit('parterfn')
    },
    langheight() {
      // 计算下拉语言框高度
      const ele = document.getElementById('langheight')
      const h = document.documentElement && document.documentElement.clientHeight
      // console.log(document.documentElement.clientHeight, 999)
      if (!ele || h > 700) return
      ele.style.height = '400px'
      ele.style.overflow = 'auto'
    },
    tablangfn(val) {
      // 客户端切语言
      window.location.href = `/${val}/${this.$store.state.path}`
    },
    getvh() {
      const vh1 = window.innerHeight * 0.01
      // 然后，我们将——vh自定义属性中的值设置为文档的根
      document.documentElement.style.setProperty('--vh', `${vh1}px`)
      window.addEventListener('resize', () => {
        // 我们执行与前面相同的脚本
        const vh2 = window.innerHeight * 0.01
        console.log(vh2)
        document.documentElement.style.setProperty('--vh', `${vh2}px`)
      })
    }
  }
}
